export default __webpack_public_path__ + "static/media/WADDCOs.78e1472f.png";